import { render } from "./TableGenerator.vue?vue&type=template&id=576c614c&scoped=true&ts=true"
import script from "./TableGenerator.vue?vue&type=script&lang=ts"
export * from "./TableGenerator.vue?vue&type=script&lang=ts"

import "./TableGenerator.vue?vue&type=style&index=0&id=576c614c&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-576c614c"]])

export default __exports__